import React, { useEffect, useMemo } from 'react';
import { apiHolder as api, apis, locationHelper } from 'api';
import { useAppDispatch, useAppSelector } from '@web-common/state/createStore';
import { Thunks } from '@web-common/state/reducer/mailReducer';
import useMsgRenderCallback from '@web-common/hooks/useMsgRenderCallback';
import useState2RM from '@web-mail/hooks/useState2ReduxMock';
import { tabId, tabType } from '@web-common/state/reducer/mailTabReducer';
import { useState2SubordinateSlice } from '@web-mail/hooks/useState2SliceRedux';
const mailApi = api.api.requireLogicalApi(apis.mailApiImpl);
const SubordinateMailBoxEventHandler = () => {
    const dispatch = useAppDispatch();
    const currentTabId = useAppSelector(state => state.mailTabReducer.currentTab.id);
    const currentTabType = useAppSelector(state => state.mailTabReducer.currentTab.type);
    const sliceId = useMemo(() => {
        let id = currentTabId;
        if (currentTabType !== tabType.subordinate) {
            id = tabId.subordinate;
        }
        return id;
    }, [currentTabId, currentTabType]);
    const [, setHideMessage] = useState2RM('hideMessage', 'doUpdateMsgHideMessage');
    const [selectedMail] = useState2SubordinateSlice('selectedMailId', undefined, sliceId);
    const [, setActiveIds] = useState2SubordinateSlice('activeIds', undefined, sliceId);
    const [, setRefreshBtnLoading] = useState2SubordinateSlice('refreshBtnLoading', undefined, sliceId);
    const [inputValue] = useState2SubordinateSlice('mailSearchKey');
    const [mailSearchState] = useState2SubordinateSlice('mailSearchState');
    const [searchType] = useState2SubordinateSlice('mailSearchType');
    const [mailSearchRecord] = useState2SubordinateSlice('mailSearchRecord');
    const [isSearchRecorded, setIsSearchRecorded] = useState2SubordinateSlice('isSearchRecorded');
    const [searchMail, setSearchMail] = useState2SubordinateSlice('activeSearchMailId');
    const isSearching = useMemo(() => !!mailSearchState, [mailSearchState]);
    const isCommonSearch = useMemo(() => mailSearchState === 'more_server' || mailSearchState === 'server', [mailSearchState]);
    const [, setGroupCollapseKeys] = useState2SubordinateSlice('groupCollapseKeys');
    const [, setSearchGroupCollapseKeys] = useState2SubordinateSlice('searchGroupCollapseKeys');
    const [selectedSubordinateKeys] = useState2SubordinateSlice('selectedSubordinateKeys');
    const isSdTab = useMemo(() => currentTabId === tabId.subordinate, [currentTabId]);
    const refreshFolderHandler = (showLoading = false) => {
    };
    useEffect(() => {
        if (isSearching) {
            setGroupCollapseKeys([]);
        }
        else {
            setSearchGroupCollapseKeys([]);
        }
    }, [isSearching]);
    useEffect(() => {
        if (isSearching) {
            setSearchGroupCollapseKeys([]);
        }
        setGroupCollapseKeys([]);
    }, [selectedSubordinateKeys, selectedMail]);
    useEffect(() => {
        setIsSearchRecorded(false);
    }, [searchType]);
    useEffect(() => {
        if (isCommonSearch && searchMail && mailSearchRecord && !isSearchRecorded) {
            setIsSearchRecorded(true);
            mailApi.doSaveMailSearchRecord_sd({ type: searchType, content: inputValue }).then();
        }
    }, [isCommonSearch, searchMail, isSearchRecorded, mailSearchRecord]);
    const handleMailChange = (ev) => {
        if (!isSdTab) {
            return;
        }
        try {
            const { eventStrData } = ev;
            if (eventStrData === 'data') {
            }
            else if (eventStrData == 'refresh') {
                refreshEmailList({ noCache: true, accountId: '' });
                refreshFolderHandler();
            }
            else if (eventStrData == 'refreshFolder') {
                if (locationHelper.testPathMatch('/')) {
                    refreshFolderHandler();
                }
            }
            else if (eventStrData == 'syncFolder') {
                if (locationHelper.testPathMatch('/')) {
                    refreshFolderHandler();
                }
            }
            else if (eventStrData == 'showDescChange' || eventStrData == 'showAttachmentChange') {
                refreshEmailList({ accountId: '' });
            }
        }
        catch (e) {
            console.error(e);
        }
    };
    const handleColleagueEdmNotify = () => {
        setRefreshBtnLoading(false);
        refreshFolderHandler();
        refreshMailContent();
    };
    const refreshMailContent = () => {
        if (selectedMail.id) {
            mailApi.doGetTpMailContent({
                mid: selectedMail.id,
                owner: selectedMail.owner,
                subEmail: selectedMail.subEmail,
                colleagueAccId: selectedMail.colleagueAccId,
            }, true);
        }
    };
    const refreshEmailList = (param = {}) => {
        const { noCache = false, showLoading = true, accountId } = param;
        dispatch(Thunks.loadMailList_edm({
            noCache,
            showLoading,
            accountId,
            type: 'subordinate',
            sliceId,
        }));
    };
    useMsgRenderCallback('mailStatesChanged', ev => {
        if (!isSdTab) {
            return;
        }
        try {
            if (ev && !ev.isStick) {
                const { eventStrData, eventData = {} } = ev;
                const { hideMessage: _hideMessage } = eventData;
                setHideMessage(!!_hideMessage);
                if (eventStrData === 'clearCheckedMails') {
                    setActiveIds([]);
                    return;
                }
            }
        }
        catch (e) {
            console.error(e);
        }
    });
    return React.createElement(React.Fragment, null);
};
export default SubordinateMailBoxEventHandler;
